// extracted by mini-css-extract-plugin
export default {"actions":"Calculation_actions__DY2jJ"};